import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretRight, faCaretLeft } from '@fortawesome/free-solid-svg-icons';
import { YearProps } from 'src/features/public-profile/components/yearly-activity-tab/components/year/year.types';
import { StyledIconWrapper, StyledYearContainer, StyledYearValue } from './year.styles';
export const Year = ({
  onRightClick,
  year,
  onLeftClick
}: YearProps) => <StyledYearContainer data-sentry-element="StyledYearContainer" data-sentry-component="Year" data-sentry-source-file="year.tsx">
    <StyledIconWrapper onClick={onLeftClick} aria-label="Previous Year" data-testid="left-caret" data-sentry-element="StyledIconWrapper" data-sentry-source-file="year.tsx">
      <FontAwesomeIcon icon={faCaretLeft} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="year.tsx" />
    </StyledIconWrapper>
    <StyledYearValue data-testid="year-value" data-sentry-element="StyledYearValue" data-sentry-source-file="year.tsx">{year}</StyledYearValue>
    <StyledIconWrapper onClick={onRightClick} aria-label="Next Year" data-testid="right-caret" data-sentry-element="StyledIconWrapper" data-sentry-source-file="year.tsx">
      <FontAwesomeIcon icon={faCaretRight} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="year.tsx" />
    </StyledIconWrapper>
  </StyledYearContainer>;